import { offerChanges } from "venuescanner-backend/app/helpers/offerChanges";
import country from "venuescanner-js/utils/country";

const enquiryChangesModel = ({ thread, message }) => {

  const { country_code } = thread._venue;
  const Country = country(country_code);
  const currency = Country.currency;
  const changes = offerChanges({ message, thread, currency });

  if (!changes) return null;
  return Object.values(changes);
};

export default enquiryChangesModel;
